<div class="alarm_screen">
  <div class="alarm_container">
    <div class="alarm_header">
      <h4>Upload File</h4>
    </div>
    <div class="alarm_body">
      <div class="row">
        File already exists,Do you want to update?

      </div>
      <div class="alarm_actions">
        <div class="btnstyles">
          <button class="btn uploadstyle" (click)="uploadFile()" >
            Upload
          </button>
          <button class="btn btn-light" (click)="close()">Cancel</button>
        </div>
      </div>
    </div>
  </div>